import {useEffect} from 'react';
import {useNavigate, useParams} from 'react-router-dom';

/**
 * TaskRedirect component handles legacy  URLs that contained path suffixes
 * Old format: task/{task_id}/demo-stinger-product-rep
 * New format: task/{task_id}
 *
 * This component redirects old URLs to the new simplified format
 */
const TaskRedirect = () => {
  const navigate = useNavigate();
  const {task_id} = useParams<{task_id: string}>();

  useEffect(() => {
    if (task_id) {
      // Redirect to the new simplified task route
      navigate(`/task/${task_id}`, {replace: true});
    }
  }, [task_id, navigate]);

  return null;
};

export default TaskRedirect;
